import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {CandidatService} from "../../../../services/candidat.service";
import {Candidat} from "../../../../models/Candidat";
import {AuthService} from "../../../../services/auth.service";

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrl: './details.component.scss'
})
export class DetailsComponent implements OnInit {

  candidat: Candidat
  loading = false;
  constructor(
    private candidatService: CandidatService,
    private auth: AuthService,
    public dialogRef: MatDialogRef<DetailsComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {


  }

  ngOnInit(): void {
    // this.getCandidatById()
    this.getCandidateDetailByIdEstaId()
  }

  round(num: number) {
    return Math.round(num)
  }


  onDialogClose(): void {
    this.dialogRef.close();
  }
  getCandidatById() {
    // this.candidatService.getCondidatById(this.data.candidature.candidatId).subscribe({
     // next: data => {
     //   // this.candidat = data;
     // }
    // });
  }
  getEvaluationByCandidatId() {
     this.candidatService.getEvaluationByCandidatId(this.data.candidature.candidatId).subscribe({
       next: data => {
         this.candidat.ratingCount = data?.details?.length || 0;
      }
    });
  }
  getCandidateDetailByIdEstaId() {
    this.loading = true;
    this.candidatService.getCandidatDetailByIdEstaIdV2(this.data.candidature.candidatId, this.auth.id!).subscribe({
      next: data => {
        this.candidat = data;
        if (this.candidat?.birthDay)
        {
          this.candidat.age = this.calculateYears(this.candidat?.birthDay);
        }
        if (this.candidat?.graduationYear)
        {
          this.candidat.yearsOfExperiances = this.calculateYears(this.candidat?.graduationYear);
        }
        if (this.candidat?.creationDate)
        {
          this.candidat.inscriptionYears = this.getAccountCreationString(this.candidat?.creationDate);
        }
        try {
          this.getEvaluationByCandidatId();
        } catch 
        {

        }
       
        this.loading = false;
      }
    });
  }
 getAccountCreationString(creationDate: string): string {
  const creation = new Date(creationDate);
  const day = creation.getUTCDate();
  const month = creation.getUTCMonth() + 1; 
  const year = creation.getUTCFullYear();
  const formattedDay = day < 10 ? `0${day}` : day.toString();
  const formattedMonth = month < 10 ? `0${month}` : month.toString();
  return `${formattedDay}-${formattedMonth}-${year}`;
}


  calculateYears(date: string): number {
  const valueDate = new Date(date);
  const today = new Date();

  let age = today.getFullYear() - valueDate.getFullYear();
  const monthDifference = today.getMonth() - valueDate.getMonth();
  const dayDifference = today.getDate() - valueDate.getDate();

  // Adjust age if the current date is before the birthdate in the current year
  if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
    age--;
  }

  return age;
}


}
